// plan-08 S04: iframe + chrome + ascent — bible §26

import { playMaterializationSeal } from '../../audio/portal'

let chromeEl: HTMLElement | null = null
let iframeEl: HTMLIFrameElement | null = null
let escHandler: ((e: KeyboardEvent) => void) | null = null
let loadTimeout: ReturnType<typeof setTimeout> | null = null
let onAscendCb: (() => void) | null = null

const LOAD_TIMEOUT_MS = 10000

interface IframeOpts {
  onAscend: () => void
  onFailure: () => void
}

export function mountIframe(opts: IframeOpts): void {
  onAscendCb = opts.onAscend

  const s = { audioMuted: false }
  try {
    const saved = JSON.parse(localStorage.getItem('vt.save') ?? '{}')
    s.audioMuted = saved.audioMuted ?? false
  } catch { /* ignore */ }

  chromeEl = document.createElement('div')
  chromeEl.className = 'vt-portal-chrome'

  // breadcrumb top-left
  const breadcrumb = document.createElement('div')
  breadcrumb.className = 'vt-portal-breadcrumb'
  breadcrumb.textContent = '// undernet > vague_souls'
  chromeEl.appendChild(breadcrumb)

  // ascend button top-right
  const ascendBtn = document.createElement('button')
  ascendBtn.className = 'vt-portal-ascend-btn'
  ascendBtn.textContent = '[ ascend ]'
  ascendBtn.addEventListener('click', (e) => {
    e.stopPropagation()
    ascend()
  })
  chromeEl.appendChild(ascendBtn)

  // iframe
  iframeEl = document.createElement('iframe')
  iframeEl.className = 'vt-portal-iframe'
  iframeEl.src = 'https://vaguesouls.xyz/?embed=1&from=vpk'
  iframeEl.title = 'vague souls'
  iframeEl.setAttribute(
    'sandbox',
    'allow-scripts allow-same-origin allow-pointer-lock allow-fullscreen',
  )
  iframeEl.setAttribute('allowfullscreen', '')

  // load handling
  let loaded = false
  iframeEl.addEventListener('load', () => {
    loaded = true
    if (loadTimeout !== null) {
      clearTimeout(loadTimeout)
      loadTimeout = null
    }
    // materialization seal
    if (!s.audioMuted) playMaterializationSeal()
  })

  iframeEl.addEventListener('error', () => {
    if (!loaded) showFallback()
  })

  chromeEl.appendChild(iframeEl)
  document.body.appendChild(chromeEl)

  // timeout fallback
  loadTimeout = setTimeout(() => {
    if (!loaded) showFallback()
  }, LOAD_TIMEOUT_MS)

  // Esc key
  escHandler = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault()
      ascend()
    }
  }
  document.addEventListener('keydown', escHandler)
}

export function unmountIframe(): void {
  if (escHandler) {
    document.removeEventListener('keydown', escHandler)
    escHandler = null
  }
  if (loadTimeout !== null) {
    clearTimeout(loadTimeout)
    loadTimeout = null
  }
  if (chromeEl) {
    chromeEl.remove()
    chromeEl = null
  }
  iframeEl = null
  onAscendCb = null
}

function ascend(): void {
  onAscendCb?.()
}

function showFallback(): void {
  if (loadTimeout !== null) {
    clearTimeout(loadTimeout)
    loadTimeout = null
  }
  if (iframeEl) {
    iframeEl.remove()
    iframeEl = null
  }

  if (!chromeEl) return

  const fallback = document.createElement('div')
  fallback.className = 'vt-portal-fallback'

  const msg = document.createElement('div')
  msg.className = 'vt-portal-fallback-msg'
  msg.textContent = '> dream offline. proximity: probably.'
  fallback.appendChild(msg)

  const retryBtn = document.createElement('button')
  retryBtn.className = 'vt-portal-fallback-btn'
  retryBtn.textContent = '[ retry ]'
  retryBtn.addEventListener('click', (e) => {
    e.stopPropagation()
    fallback.remove()
    // re-mount iframe
    const iframe = document.createElement('iframe')
    iframe.className = 'vt-portal-iframe'
    iframe.src = 'https://vaguesouls.xyz/?embed=1&from=vpk'
    iframe.title = 'vague souls'
    iframe.setAttribute(
      'sandbox',
      'allow-scripts allow-same-origin allow-pointer-lock allow-fullscreen',
    )
    iframe.setAttribute('allowfullscreen', '')
    let loaded = false
    iframe.addEventListener('load', () => {
      loaded = true
    })
    iframe.addEventListener('error', () => {
      if (!loaded) showFallback()
    })
    iframeEl = iframe
    chromeEl!.appendChild(iframe)

    loadTimeout = setTimeout(() => {
      if (!loaded) showFallback()
    }, LOAD_TIMEOUT_MS)
  })
  fallback.appendChild(retryBtn)

  chromeEl.appendChild(fallback)
}
